module.exports = __webpack_public_path__ + "img/houseVirtualrowFSFBWhite.b8316d2c.svg";